import { StringIndexedDict } from "../../../../api/GenericTypes";
import {
  GenericEntityVirtualizedEntitySelectFormFieldProps,
  GenericVirtualizedEntitySelectFormFieldControllerWrapper,
} from "../../../formfields/GenericVirtualizedSelectFormField/GenericVirtualizedEntitySelectFormFieldControllerWrapper";
import { useContext } from "react";
import { SessionContext } from "../../../contexts/SessionContext";
import { useEntityCount } from "../../../../api/BaseEntityApi";
import { LoadingWrapper } from "../../../LoadingWrapper";
import { CustomTypeSuggestions } from "../../../../api/CustomTypes/CustomTypesBase";
import {
  customTypeConstants,
  CustomTypeFilters,
  CustomTypeSortingOptionsConsts,
  minimalCustomType,
} from "../../../../api/CustomTypes/CustomTypes";

export const CustomTypesVirtualizedSelectForm = <Entity extends StringIndexedDict>(
  props: GenericEntityVirtualizedEntitySelectFormFieldProps<Entity, CustomTypeSuggestions, CustomTypeFilters> & {
    enableBasicOption?: boolean;
    hideIfNoTypes?: boolean;
  }
) => {
  const { session } = useContext(SessionContext);

  const {
    data: countQuery,
    status,
    fetchStatus,
  } = useEntityCount(customTypeConstants.resource, props.filters, {
    enabled: !!props.hideIfNoTypes,
  });
  return (
    <LoadingWrapper status={status} fetchStatus={fetchStatus} type="skeleton-block">
      {props.hideIfNoTypes && countQuery?.count === 0 ? (
        <></>
      ) : (
        <GenericVirtualizedEntitySelectFormFieldControllerWrapper<Entity, CustomTypeSuggestions, CustomTypeFilters>
          {...props}
          filters={{
            sortBy: [{ property: "NAME", sortDirection: "ASC" }],
            ...props.filters,
          }}
          entityConstants={customTypeConstants}
          orderByOptions={CustomTypeSortingOptionsConsts}
          allowCreateEntity={session?.permissions.administer_custom_field_schemas && props.allowCreateEntity}
          concatItems={
            props.enableBasicOption && !props.allowUnassigned && props.filters?.entityTypes?.length === 1
              ? [{ id: 0, name: `${minimalCustomType}` }]
              : props.concatItems
          }
        />
      )}
    </LoadingWrapper>
  );
};
